export default __webpack_public_path__ + "static/media/flare.f550b569.png";